var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/register_invite/index.tsx";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Stack, CardTitle, Text } from 'soapbox/components/ui';
import RegistrationForm from 'soapbox/features/auth_login/components/registration_form';
import { useAppSelector } from 'soapbox/hooks';
/** Page to register with an invitation. */
const RegisterInvite = () => {
  const {
    token
  } = useParams();
  const siteTitle = useAppSelector(state => state.instance.title);
  const title = /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "register_invite.title",
    defaultMessage: "You've been invited to join {siteTitle}!",
    values: {
      siteTitle
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  });
  return /*#__PURE__*/React.createElement(Stack, {
    space: 3,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    className: "mb-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(CardTitle, {
    title: title,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "register_invite.lead",
    defaultMessage: "Complete the form below to create an account.",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(RegistrationForm, {
    inviteToken: token,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }));
};
export default RegisterInvite;